import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Button } from 'components/button/Button'
import { Text } from 'components/Typography'

export type HorizontalPosition = 'left' | 'center' | 'right'
export type VerticalPosition = 'below' | 'above'

export const SPopup = styled.div<{
  show?: boolean
}>`
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 1rem;
  ${(p) =>
    !p.show
      ? css`
          display: none;
        `
      : ''}
`

export const SArrowPositioner = styled.div`
  top: 0;
`

export const SArrow = styled.div`
  background-color: white;
  width: 16px;
  height: 16px;
  transform: translateY(-50%) rotate(45deg);
`

export const SHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-bottom: 0.5rem;
`

export const STitle = styled(Text)`
  color: black;
  font-weight: bold;
  margin-right: 0.5rem;
`

export const SCloseButton = styled(Button)`
  z-index: 1;
  margin-left: auto;
  width: auto;
  height: auto;
  padding: 0.4rem 0;
  align-items: flex-start;
`
